const scope = `limitationMessageOffer/`;
export const SET_LOADING_FLAG = `${scope}SET_LOADING_FLAG`;
export const SET_LIMIT_OFFER_OBSERVATION = `${scope}SET_LIMIT_OFFER_OBSERVATION`;
export const SET_LIMIT_OFFER_FORMS = `${scope}SET_LIMIT_OFFER_FORMS`;
export const GET_LIMIT_OFFER = `${scope}GET_LIMIT_OFFER`;
